// Diccionario de enlaces y abreviaciones
// Mapea términos cortos, subdominios y patrones comunes a nombres de plataformas

export const diccionarioEnlaces = {
  // Redes Sociales - Abreviaciones comunes
  'wa': 'WhatsApp',
  'ig': 'Instagram',
  'fb': 'Facebook',
  'tw': 'Twitter',
  'yt': 'YouTube',
  'li': 'LinkedIn',
  'tk': 'TikTok',
  'tg': 'Telegram',
  'sc': 'Snapchat',
  'pin': 'Pinterest',
  'rd': 'Reddit',
  'dc': 'Discord',
  'sp': 'Spotify',
  
  // Plataformas de video/streaming
  'youtube': 'YouTube',
  'youtu': 'YouTube', // Para youtu.be
  'vimeo': 'Vimeo',
  'twitch': 'Twitch',
  'netflix': 'Netflix',
  'hulu': 'Hulu',
  'primevideo': 'Prime Video',
  'disney': 'Disney+',
  'hbo': 'HBO Max',
  
  // Redes sociales principales
  'instagram': 'Instagram',
  'facebook': 'Facebook',
  'twitter': 'Twitter',
  'linkedin': 'LinkedIn',
  'tiktok': 'TikTok',
  'whatsapp': 'WhatsApp',
  'telegram': 'Telegram',
  'snapchat': 'Snapchat',
  'pinterest': 'Pinterest',
  'reddit': 'Reddit',
  'discord': 'Discord',
  'clubhouse': 'Clubhouse',
  'mastodon': 'Mastodon',
  'threads': 'Threads',
  'x': 'X (Twitter)',
  
  // Plataformas profesionales
  'github': 'GitHub',
  'gitlab': 'GitLab',
  'bitbucket': 'Bitbucket',
  'behance': 'Behance',
  'dribbble': 'Dribbble',
  'medium': 'Medium',
  'dev': 'Dev.to',
  'stackoverflow': 'Stack Overflow',
  'codepen': 'CodePen',
  'figma': 'Figma',
  'notion': 'Notion',
  
  // E-commerce y tiendas
  'amazon': 'Amazon',
  'mercadolibre': 'Mercado Libre',
  'mercadopago': 'Mercado Pago',
  'shopify': 'Shopify',
  'etsy': 'Etsy',
  'ebay': 'eBay',
  'aliexpress': 'AliExpress',
  'alibaba': 'Alibaba',
  'walmart': 'Walmart',
  'target': 'Target',
  
  // Pagos y finanzas
  'paypal': 'PayPal',
  'stripe': 'Stripe',
  'venmo': 'Venmo',
  'cashapp': 'Cash App',
  'zelle': 'Zelle',
  'wise': 'Wise',
  'revolut': 'Revolut',
  'nequi': 'Nequi',
  'daviplata': 'DaviPlata',
  'bancolombia': 'Bancolombia',
  
  // Música y audio
  'spotify': 'Spotify',
  'apple': 'Apple Music',
  'amazon': 'Amazon Music',
  'deezer': 'Deezer',
  'soundcloud': 'SoundCloud',
  'pandora': 'Pandora',
  'tidal': 'Tidal',
  'audiomack': 'Audiomack',
  'bandcamp': 'Bandcamp',
  
  // Google Services
  'gmail': 'Gmail',
  'google': 'Google',
  'gdrive': 'Google Drive',
  'gphoto': 'Google Photos',
  'gmaps': 'Google Maps',
  'gcalendar': 'Google Calendar',
  'gplay': 'Google Play',
  'gsearch': 'Google Search',
  
  // Microsoft Services
  'outlook': 'Outlook',
  'onedrive': 'OneDrive',
  'office': 'Microsoft Office',
  'teams': 'Microsoft Teams',
  'xbox': 'Xbox',
  'skype': 'Skype',
  
  // Apple Services
  'icloud': 'iCloud',
  'appstore': 'App Store',
  'itunes': 'iTunes',
  'facetime': 'FaceTime',
  
  // Mensajería y comunicación
  'zoom': 'Zoom',
  'meet': 'Google Meet',
  'hangouts': 'Google Hangouts',
  'webex': 'Webex',
  'slack': 'Slack',
  'messenger': 'Messenger',
  'viber': 'Viber',
  'wechat': 'WeChat',
  'line': 'Line',
  'kakaotalk': 'KakaoTalk',
  
  // Educación y aprendizaje
  'coursera': 'Coursera',
  'udemy': 'Udemy',
  'khan': 'Khan Academy',
  'duolingo': 'Duolingo',
  'babbel': 'Babbel',
  'skillshare': 'Skillshare',
  'masterclass': 'MasterClass',
  'pluralsight': 'Pluralsight',
  
  // Noticias y medios
  'cnn': 'CNN',
  'bbc': 'BBC',
  'reuters': 'Reuters',
  'ap': 'Associated Press',
  'nyt': 'New York Times',
  'wsj': 'Wall Street Journal',
  'guardian': 'The Guardian',
  'forbes': 'Forbes',
  
  // Dating y sociales
  'tinder': 'Tinder',
  'bumble': 'Bumble',
  'hinge': 'Hinge',
  'match': 'Match.com',
  'pof': 'Plenty of Fish',
  'grindr': 'Grindr',
  'her': 'HER',
  
  // Transporte y viajes
  'uber': 'Uber',
  'lyft': 'Lyft',
  'airbnb': 'Airbnb',
  'booking': 'Booking.com',
  'expedia': 'Expedia',
  'tripadvisor': 'TripAdvisor',
  'kayak': 'Kayak',
  'skyscanner': 'Skyscanner',
  
  // Comida y delivery
  'ubereats': 'Uber Eats',
  'doordash': 'DoorDash',
  'grubhub': 'Grubhub',
  'postmates': 'Postmates',
  'rappi': 'Rappi',
  'ifood': 'iFood',
  'zomato': 'Zomato',
  'seamless': 'Seamless',
  
  // Gaming
  'steam': 'Steam',
  'epic': 'Epic Games',
  'origin': 'Origin',
  'battlenet': 'Battle.net',
  'gog': 'GOG',
  'itch': 'itch.io',
  'roblox': 'Roblox',
  'minecraft': 'Minecraft',
  
  // Productividad
  'trello': 'Trello',
  'asana': 'Asana',
  'monday': 'Monday.com',
  'airtable': 'Airtable',
  'dropbox': 'Dropbox',
  'box': 'Box',
  'evernote': 'Evernote',
  'onenote': 'OneNote',
  
  // Subdominios comunes
  'm': 'Mobile', // m.facebook.com
  'www': 'Web',
  'mobile': 'Mobile',
  'app': 'App',
  'api': 'API',
  'blog': 'Blog',
  'news': 'Noticias',
  'support': 'Soporte',
  'help': 'Ayuda',
  'about': 'Acerca de',
  'contact': 'Contacto',
  'shop': 'Tienda',
  'store': 'Tienda',
  'admin': 'Admin',
  'dashboard': 'Panel',
  
  // Extensiones de dominio comunes (para contexto)
  'com': 'Comercial',
  'org': 'Organización',
  'edu': 'Educación',
  'gov': 'Gobierno',
  'net': 'Red',
  'co': 'Compañía',
  'io': 'Tech',
  'ai': 'Inteligencia Artificial',
  'app': 'Aplicación',
  'dev': 'Desarrollo',
  
  // Países para dominios
  'mx': 'México',
  'ar': 'Argentina',
  'co': 'Colombia',
  'cl': 'Chile',
  'pe': 'Perú',
  'br': 'Brasil',
  'es': 'España',
  'uk': 'Reino Unido',
  'ca': 'Canadá',
  'au': 'Australia',
  'de': 'Alemania',
  'fr': 'Francia',
  'it': 'Italia',
  'jp': 'Japón',
  'kr': 'Corea',
  'cn': 'China',
  'in': 'India',
  'ru': 'Rusia',
  
  // Plataformas latinoamericanas específicas
  'nequi': 'Nequi',
  'daviplata': 'DaviPlata',
  'pse': 'PSE',
  'efecty': 'Efecty',
  'baloto': 'Baloto',
  'gana': 'Gana',
  'supergiros': 'SuperGiros',
  'servientrega': 'Servientrega',
  '4-72': '4-72',
  'interrapidisimo': 'Interrapidísimo',
  'coordinadora': 'Coordinadora',
  'envia': 'Envía',
  
  // Bancos comunes
  'bancolombia': 'Bancolombia',
  'bbva': 'BBVA',
  'davivienda': 'Davivienda',
  'banco': 'Banco',
  'santander': 'Santander',
  'citibank': 'Citibank',
  'hsbc': 'HSBC',
  'scotiabank': 'Scotiabank',
  'banorte': 'Banorte',
  'banamex': 'Banamex',
  
  // Patrones especiales
  'whatsapp.com': 'WhatsApp',
  'wa.me': 'WhatsApp',
  'chat.whatsapp.com': 'WhatsApp Chat',
  'web.whatsapp.com': 'WhatsApp Web',
  'youtu.be': 'YouTube',
  't.me': 'Telegram',
  'bit.ly': 'Bitly',
  'tinyurl.com': 'TinyURL',
  'short.link': 'Short Link',
  'link.tree': 'Linktree',
  'linktr.ee': 'Linktree',
  'bio.link': 'Bio Link',
  'tap.bio': 'Tap Bio'
}

// Función para buscar el nombre de la plataforma
export const buscarNombrePlataforma = (termino) => {
  if (!termino) return ''
  
  const terminoLimpio = termino.toLowerCase().trim()
  
  // Buscar coincidencia exacta primero
  if (diccionarioEnlaces[terminoLimpio]) {
    return diccionarioEnlaces[terminoLimpio]
  }
  
  // Buscar coincidencias parciales (por si el término contiene más información)
  for (const [clave, valor] of Object.entries(diccionarioEnlaces)) {
    if (terminoLimpio.includes(clave) || clave.includes(terminoLimpio)) {
      return valor
    }
  }
  
  // Si no se encuentra, retornar el término capitalizado
  return termino.charAt(0).toUpperCase() + termino.slice(1).toLowerCase()
}

// Función para extraer información de URL compleja
export const analizarURL = (url) => {
  if (!url) return { dominio: '', subdominio: '', nombre: '' }
  
  try {
    const urlObj = new URL(url)
    let hostname = urlObj.hostname.toLowerCase()
    
    // Separar subdominios
    const partes = hostname.split('.')
    const dominioPrincipal = partes.length >= 2 ? partes[partes.length - 2] : partes[0]
    const subdominio = partes.length > 2 ? partes.slice(0, -2).join('.') : ''
    
    // Buscar el nombre de la plataforma
    const nombrePlataforma = buscarNombrePlataforma(dominioPrincipal)
    
    return {
      dominio: dominioPrincipal,
      subdominio: subdominio,
      nombre: nombrePlataforma,
      esMovil: subdominio.includes('m.') || subdominio.includes('mobile'),
      esApp: subdominio.includes('app'),
      hostname: hostname
    }
  } catch (error) {
    return { dominio: '', subdominio: '', nombre: '' }
  }
}

export default diccionarioEnlaces 